export default {
    //RecordsList
    your_records: 'Your recordings',
    loading_records: 'Loading recordings...',
    project_name: 'Course Name',
    class_name: 'Class Name',
    participants: 'Participants',
    total_size: 'Total size',

}